// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8c89b8a","453":"1ed97612","455":"f080c420","977":"795d5529"}[chunkId] + ".chunk.js";
};